export class MarketingOptionsParametersModel {
    id: any;
    description: string;
    code: string;
    value: number;
    isEditable :boolean = false;
}
